
export default {
    btnSSO_Orange: "#F75710",
    btnSSO_Blue: "#29529E",
};